import { ProviderInfoPayment } from 'src/models/provider';
import { Action, State, types } from '.';
import { storeWorkflowContextData } from 'src/utils/workflow';
import { WorkflowContext } from 'src/utils/constValues';
import { ClinicInformationRequest } from 'src/models/clinic';
import { getProviderInformationPayment } from '../provider/reducer';

// New Step03
export const storeProviderInformationPaymentWithClinic = (clinicInformation: ClinicInformationRequest): ProviderInfoPayment => {
    let currrentProviderInfo = getProviderInformationPayment();

    if (currrentProviderInfo && currrentProviderInfo.physicianName) {
        let newProviderInfo: ProviderInfoPayment = {
            ...currrentProviderInfo,
            clinics: clinicInformation.clinics
        };

        const providerState = JSON.stringify(newProviderInfo);
        if (storeWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT.toString(), providerState)) {
            return newProviderInfo;
        }
    }

    return {} as ProviderInfoPayment;
};

const initialState: State = {
    saving: false,
    saved: false,
    isPass: false,

    statusCode: undefined,
    errorMessage: '',

    provider: getProviderInformationPayment()
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ADD_CLINIC_INFORMATION_ASYNC:
            return {
                ...state,
                saving: true,
                saved: false,
            };

        case types.ADD_CLINIC_INFORMATION_SUCCEED:
            return {
                ...state,
                saving: false,
                saved: true,
                isPass: action.isPass
            };

        case types.ADD_CLINIC_INFORMATION_FAILED:
            return {
                ...state,
                saving: false,
                saved: false,
                errorMessage: action.errorMessage
            };

        case types.STORE_PROVIDER_INFORMATION_PAYMENT_WITH_CLINIC:
            return {
                ...state,
                provider: storeProviderInformationPaymentWithClinic(action.clinicInformation)
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/clinic/reducer.ts